(() => {
  const main = document.getElementById('MainContent');
  if (!main) return;
  const initializedSorts = new WeakSet();
  const recommendationTracks = new WeakSet();
  // Load photo reviews in the collapsed preview too. Judge.me's native
  // not-scroll-to flag prevents an initial sort from moving the product page.
  function requestPhotoReviews() {
    main.querySelectorAll('.jdgm-sort-dropdown').forEach(select => {
      if (initializedSorts.has(select) || !select.querySelector('option[value="pictures-first"]')) return;
      const widget = select.closest('.jdgm-review-widget');
      if (!widget?.classList.contains('jdgm--done-setup-widget') || !window.jdgm?.$) return;
      const nativeWidget = window.jdgm.$(widget);
      if (typeof nativeWidget.data('before-callback') !== 'function') return;
      initializedSorts.add(select);
      if (!select.isConnected || select.value !== 'most-recent') return;
      nativeWidget.data('not-scroll-to', true);
      select.value = window.HolyTheme?.hs_reviews_sort || 'pictures-first';
      select.dispatchEvent(new Event('change', {bubbles:true}));
    });
  }
  main.addEventListener('click', event => {
    if (event.target.closest('.jdgm-prev-badge__stars')) requestPhotoReviews();
  }, true);
  function enhance() {
    requestPhotoReviews();
    // Keep Judge.me labels and imported names legible in this theme only.
    const reviewLabels = {
      'Customer Reviews': 'Avaliações de clientes',
      'Write a review': 'Escrever uma avaliação',
      'No reviews': 'Seja o primeiro a avaliar',
      'No reviews yet': 'Seja o primeiro a avaliar',
      'Sem avaliações': 'Seja o primeiro a avaliar',
      'Sort by': 'Ordenar por'
    };
    main.querySelectorAll('.jdgm-widget').forEach(widget => {
      widget.querySelectorAll('.jdgm-rev-widg__title,.jdgm-write-rev-link,.jdgm-prev-badge__text,.jdgm-sort-dropdown-label').forEach(label => {
        const translated = reviewLabels[label.textContent.trim()];
        if (translated && label.textContent !== translated) label.textContent = translated;
      });
      widget.querySelectorAll('.jdgm-rev__author').forEach(author => {
        const name = author.textContent.trim();
        if (!name.includes('+') && !/%[0-9a-f]{2}/i.test(name)) return;
        let decoded;
        try { decoded = decodeURIComponent(name.replace(/\+/g, '%20')); }
        catch { decoded = name.replace(/\+/g, ' '); }
        if (decoded !== name) author.textContent = decoded;
      });
    });
    main.querySelectorAll('.cbb-also-bought-container').forEach(section => {
      const track = section.querySelector('.cbb-also-bought-slider');
      const list = section.querySelector('.cbb-also-bought-slider-list');
      if (!track || !list || !list.children.length || recommendationTracks.has(track)) return;
      recommendationTracks.add(track);
      section.querySelector('.hs-recommendation-nav')?.remove();
      const nav = document.createElement('div');
      nav.className = 'hs-recommendation-nav';
      const controls = [-1, 1].map(direction => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', direction < 0 ? 'Produtos anteriores' : 'Próximos produtos');
        button.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${direction < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7'}"/></svg>`;
        button.addEventListener('click', () => {
          const card = list.firstElementChild;
          const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(list).gap) || 0);
          track.scrollBy({left:direction * step * Math.max(1, Math.floor(track.clientWidth / step)), behavior:'smooth'});
        });
        nav.append(button);
        return button;
      });
      section.append(nav);
      const update = () => {
        controls[0].disabled = track.scrollLeft < 2;
        controls[1].disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      track.addEventListener('scroll', update, {passive:true});
      const resize = new ResizeObserver(update);
      resize.observe(track);
      resize.observe(list);
      update();
      let drag = null;
      let dragged = false;
      track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || !matchMedia('(min-width:1025px)').matches || event.target.closest('button,select,input')) return;
        drag = {x:event.clientX, left:track.scrollLeft, id:event.pointerId};
        dragged = false;
      });
      track.addEventListener('pointermove', event => {
        if (!drag) return;
        if (!(event.buttons & 1)) { drag = null; track.classList.remove('hs-dragging'); return; }
        const distance = event.clientX - drag.x;
        if (!dragged && Math.abs(distance) < 6) return;
        dragged = true;
        track.setPointerCapture(drag.id);
        track.classList.add('hs-dragging');
        track.scrollLeft = drag.left - distance;
        event.preventDefault();
      });
      const endDrag = () => { drag = null; track.classList.remove('hs-dragging'); };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('lostpointercapture', endDrag);
      track.addEventListener('dragstart', event => event.preventDefault());
      track.addEventListener('click', event => {
        if (!dragged) return;
        event.preventDefault(); event.stopPropagation(); dragged = false;
      }, true);
    });
    main.querySelectorAll('.jdgm-rev').forEach(review => {
      review.querySelectorAll('.jdgm-row-product,.jdgm-row-extra,.jdgm-rev__custom-form,.jdgm-rev__title,.jdgm-rev__body,.jdgm-rev__actions').forEach(el => {
        el.classList.toggle('hs-review-empty', !el.textContent.trim() && !el.querySelector('img,video,input,button,a'));
      });
    });
    main.querySelectorAll('.jdgm-rev-widg__reviews').forEach(list => {
      const reviews = [...list.children].filter(el => el.classList.contains('jdgm-rev'));
      const priority = review => {
        const text = [...review.querySelectorAll('.jdgm-rev__title,.jdgm-rev__body')].some(el => el.textContent.trim());
        const photo = !!review.querySelector('.jdgm-rev__pic-img');
        const rating = Number(review.querySelector('.jdgm-rev__rating')?.getAttribute('data-score')) || 0;
        return (rating >= 5 ? 4 : rating >= 4 ? 2 : 0) + (photo ? 1 : 0) + (text ? 0.1 : 0);
      };
      const sorted = window.HolyTheme?.hs_reviews_sort === 'most-recent' ? reviews : [...reviews].sort((a,b) => priority(b)-priority(a));
      if (sorted.some((el,index) => el !== reviews[index])) sorted.forEach(el => list.append(el));
    });
    main.querySelectorAll('.jdgm-rev__pic-img[data-src]:not([src])').forEach(img => {
      img.loading = 'eager';
      img.addEventListener('load', () => img.closest('.jdgm-rev__pic-link')?.classList.remove('jdgm--loading'), {once:true});
      img.src = img.dataset.src;
    });
    main.querySelectorAll('.hs-comparison:not([data-ready])').forEach(section => {
      section.dataset.ready = 'true';
      const track = section.querySelector('.hs-comparison-track');
      const cards = [...track.children];
      const dots = [...section.querySelectorAll('.hs-comparison-dots button')];
      const next = section.querySelector('.hs-comparison-next');
      const go = index => track.scrollTo({left: cards[index].offsetLeft - cards[0].offsetLeft, behavior:'smooth'});
      dots.forEach((dot,index) => dot.addEventListener('click',()=>go(index)));
      if (next) {
        const prev = section.querySelector('.hs-comparison-prev') || next.cloneNode(true);
        prev.classList.remove('hs-comparison-next');
        prev.classList.add('hs-comparison-prev');
        prev.setAttribute('aria-label', 'Comparativo anterior');
        prev.querySelector('path')?.setAttribute('d', 'm15 5-7 7 7 7');
        next.before(prev);
        const current = () => cards.reduce((best,card,i)=>Math.abs(card.offsetLeft-cards[0].offsetLeft-track.scrollLeft)<Math.abs(cards[best].offsetLeft-cards[0].offsetLeft-track.scrollLeft)?i:best,0);
        prev.addEventListener('click',()=>go(Math.max(0,current()-1)));
        next.addEventListener('click',()=>go(Math.min(cards.length-1,current()+1)));
      }
      track.addEventListener('scroll',()=>{
        const index = cards.reduce((best,card,i)=>Math.abs(card.offsetLeft-cards[0].offsetLeft-track.scrollLeft)<Math.abs(cards[best].offsetLeft-cards[0].offsetLeft-track.scrollLeft)?i:best,0);
        dots.forEach((dot,i)=>{if(i===index) dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
      },{passive:true});
    });
    main.querySelectorAll('.jdgm-rev-widg:not([data-hs-ready])').forEach(widget => {
      if (!widget.querySelector('.jdgm-rev')) return;
      widget.dataset.hsReady = 'true';
      widget.classList.add('hs-reviews-collapsed');
      const actions = document.createElement('div');
      actions.className = 'hs-review-actions';
      const more = document.createElement('button');
      more.type = 'button';
      const count = widget.getAttribute('data-number-of-reviews');
      more.textContent = window.HolyTheme?.hs_reviews_more || (count ? `Ver as ${count} avaliações` : 'Ver todas as avaliações');
      more.setAttribute('aria-expanded','false');
      more.addEventListener('click',()=>{
        requestPhotoReviews();
        widget.classList.remove('hs-reviews-collapsed');
        more.setAttribute('aria-expanded','true');
        more.hidden = true;
      });
      actions.append(more);
      widget.append(actions);
    });
    main.querySelectorAll('.cbb-also-bought-title').forEach(title=>{
      const heading = window.HolyTheme?.hs_recommendations_heading || 'Quem comprou este também levou';
      if(title.textContent!==heading) title.textContent=heading;
    });
    main.querySelectorAll('.cbb-also-bought-add-to-cart-button .translatable').forEach(label=>{
      if(label.textContent.trim()==='Adicionar ao carrinho') label.textContent='+ adicionar';
    });
  }
  enhance();
  let scheduled=false;
  new MutationObserver(()=>{
    if(scheduled) return;
    scheduled=true;
    requestAnimationFrame(()=>{scheduled=false;enhance();});
  }).observe(main,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',enhance);
  document.addEventListener('jdgm.doneSetup',enhance);
})();
